import { TeamsTheme } from "../../themes";
export var CommunicationOptions;
(function (CommunicationOptions) {
    CommunicationOptions["Default"] = "default";
    CommunicationOptions["Welcome"] = "welcome";
    CommunicationOptions["Hello"] = "hello";
    CommunicationOptions["Empty"] = "empty";
    CommunicationOptions["Error"] = "error";
    CommunicationOptions["Thanks"] = "thanks";
})(CommunicationOptions || (CommunicationOptions = {}));
//# sourceMappingURL=CommunicationTypes.js.map